<template>
  <div class="manage-container">
    <div class="sub-nav slide-right faster">
      <router-link class="sub-nav-item" to="/manage/job-function">
        Job Function
      </router-link>
      <a
        class="sub-nav-item"
        v-for="(n, idx) in route"
        :key="idx"
        @click="choose(n.query, n.name)"
        :class="{ active: $route.query.choose === n.query }"
        >{{ n.name }}
      </a>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    route: [
      // { name: "Job Function", query: "JobFunction" },
      { name: "Work Experience", query: "JobExperience" },
      { name: "Salary Range", query: "SalaryRange" },
      { name: "Education Level", query: "Degree" },
      { name: "Language", query: "Language" },
      { name: "Language Level", query: "LanguageLevel" },
      { name: "Gender", query: "Gender" },
      { name: "Marital Status", query: "MaritalStatus" },
      { name: "Banner Category", query: "BannerType" },
      { name: "Tag", query: "Tag" },
      { name: "Job Level", query: "JobLevel" },
      { name: "Job Tag", query: "JobTag" },
      { name: "Skill Tag", query: "SkillTag" },
      { name: "Additional Tag", query: "AdditionalTag" },
      { name: "Job Post Position", query: "JobZone" },
      { name: "Company Size", query: "CompanySize" },
      { name: "Industry", query: "Industry" },
      { name: "Province", query: "Province" },
      { name: "District", query: "District" },
      { name: "Country", query: "Country" },
      { name: "Articles", query: "BlogType" },
    ],
  }),
  methods: {
    choose(val, val_name) {
      this.$router
        .push({
          name: "Choose",
          query: { choose: val, name: val_name, p: 10, q: 1 },
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.manage-container {
  display: flex;
  width: 100%;
  height: 100vh;
  z-index: 999;
  position: relative;
  z-index: 999;
  background-color: var(--bg-color);
  color: var(--text-color);
  border-radius: 0 !important;

  .sub-nav {
    border-radius: 0 !important;
    z-index: 999;
    padding: 10px;
    color: rgba(#fff, 0.5);
    overflow: auto;
    width: 100%;
    max-width: 160px;
    background-color: var(--text-color);

    a.sub-nav-item {
      width: 100%;
      text-decoration: none;
      color: #fff;
      display: block;
      white-space: nowrap;
      border-radius: 5px;
      cursor: pointer;

      font-size: var(--xsm-font);
      font-weight: 500;
      transition: all ease 0.1s;
      height: 2rem;
      display: flex;
      align-items: center;
      padding: 0 10px;
      &.active,
      &.router-link-active {
        color: #fff;
        background-color: var(--sub-color);
      }
    }
  }
}
</style>
